import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseService } from "../base/base.service";
import { ContentFactory, ContentList } from '../../squidex';
import { Observable } from 'rxjs';
import { Folder } from '../../squidex/models/folder.model';
import { ID } from '@datorama/akita';
import { AppConfigProvider } from '../../../app-config.provider';
import { FolderList } from '../../squidex/models/folder-list.model';



@Injectable({ providedIn: 'root' })
export class AssetDirectoryService extends BaseService {
  private readonly assetBaseUrl: string;
  private readonly emptyGuid: string = '00000000-0000-0000-0000-000000000000';

    
  constructor(contentFactory: ContentFactory,
    private readonly httpClient: HttpClient,
    private appConfigProvider: AppConfigProvider  ) {
    super('assetdirectory', contentFactory);
    this.assetBaseUrl = this.appConfigProvider.getAssetsBaseUrl();
    }

  createFolder(folder: Folder): Observable<Folder> {

    if (folder.folderName) {
      const url = `${this.assetBaseUrl}/folders/`;
      return this.httpClient.post(url, folder) as Observable<Folder>
    } else {
      throw (new Error('data is null when trying to create asset'));
    }
  }

  updateFolder(folder: Folder): Observable<Folder> {
    if (folder.folderName) {
      const payload = { folderName: folder.folderName };
      const url = `${this.assetBaseUrl}/folders/${folder.id}`;
      return this.httpClient.put(url, payload) as Observable<Folder>
    } else {
      throw (new Error('data is null when trying to create asset'));
    }
  }

  deleteFolder(folderId: ID): Observable<Folder> {
    const url = `${this.assetBaseUrl}/folders/${folderId}`;
    return this.httpClient.delete(url) as Observable<Folder>;
  }

  getFolders(): Observable<FolderList> {
    // this.initialize();
    const url = `${this.assetBaseUrl}/folders?parentId=${this.emptyGuid}`;
    return this.httpClient.get(url,) as Observable<FolderList>;
  }


}
